/* eslint-disable max-len */
import {
    Service,
    ServiceCode,
    ServiceIdMapper as DiServiceIdMapper,
} from '@di/servicing';

/** Legacy ACP filter / icon shortName for Corded Blinds */
const LEGACY_CORDED_BLINDS_SHORT_NAME = 'blinds';

const serviceIdsFromBookingType: { [key: string]: string } = {
    smoke: `${Service.SMOKE}`,
    smoke_between_tenancy: `${Service.SMOKE}`,
    smoke_further_works: `${Service.SMOKE}`,
    smoke_full_service: `${Service.SMOKE}`,
    smoke_upgrade_legislation_normal: `${Service.SMOKE}`,
    smoke_upgrade_legislation_require_electrician: `${Service.SMOKE}`,
    gas: `${Service.GAS}`,
    gas_further_works: `${Service.GAS}`,
    electrical: `${Service.ELECTRICAL}`,
    electrical_further_works: `${Service.ELECTRICAL}`,
    cordedblinds: `${Service.CORDED_BLINDS}`,
    blinds: `${Service.CORDED_BLINDS}`,
    'electrical,smoke': `${Service.SMOKE},${Service.ELECTRICAL}`,
};

class ServiceIdMapper extends DiServiceIdMapper {
    /**
     * 'blinds' -> 'cordedblinds'
     */
    static normalizeServiceFilterName(name: string): string {
        if (name === LEGACY_CORDED_BLINDS_SHORT_NAME) {
            return ServiceCode.CORDED_BLINDS;
        }

        return name;
    }

    static getServiceIdFromName(s: string | null): Service | null {
        if (s === LEGACY_CORDED_BLINDS_SHORT_NAME) {
            return Service.CORDED_BLINDS;
        }

        return DiServiceIdMapper.getServiceIdFromName(s);
    }

    static getServiceIdsFromBookingType(bookingType: string): string {
        // split string first into array
        const bookingTypeStringsArray = bookingType.split(',');

        // for each item in array return an array of service ids
        const serviceIdArray = bookingTypeStringsArray.map((type) => serviceIdsFromBookingType[type]);

        // convert the array into a string
        return serviceIdArray.toString();
    }

    /**
     * Normalise a list of selected sidebar / query service filter values so
     * legacy `'blinds'` matches canonical `'cordedblinds'`.
     */
    static normalizeSelectedServiceFilterNames(serviceNames: string[]): string[] {
        return [...new Set(
            serviceNames.map((name) => ServiceIdMapper.normalizeServiceFilterName(name))
        )];
    }

    /**
     * Map a service shortName (e.g. `cordedblinds`) to the documents-tab facet code
     * (e.g. `CORDED_BLINDS`). Returns undefined when the shortName is unknown.
     */
    static getDocumentServiceCode(shortName: string): string | undefined {
        const shortNameToCodeMap: Record<string, string> = {
            [ServiceCode.SMOKE]: 'SMOKE',
            [ServiceCode.ELECTRICAL]: 'ELECTRICAL',
            [ServiceCode.GAS]: 'GAS',
            [ServiceCode.CORDED_BLINDS]: 'CORDED_BLINDS',
            [LEGACY_CORDED_BLINDS_SHORT_NAME]: 'CORDED_BLINDS',
            rcd: 'RCD',
            water: 'WATER_EFFICIENCY',
            [ServiceCode.MINIMUM_STANDARDS]: 'MINIMUM_STANDARDS',
        };

        return shortNameToCodeMap[shortName];
    }
}

export {
    ServiceIdMapper,
    Service,
    ServiceCode,
    LEGACY_CORDED_BLINDS_SHORT_NAME,
};
